import styled from 'styled-components'

import { CircularLoader } from '@blade/ui-kit'
import { CheckIcon, EditIcon } from '@root/shared/ui-kit'

type State = 'edit' | 'save' | 'loading'
type Props = {
  type: 'button' | 'submit'
  state: State
  onClick?: () => void
  disabled?: boolean
}

const stateIconMap: Record<State, React.FC<{ size: number | undefined }>> = {
  edit: EditIcon,
  loading: CircularLoader,
  save: CheckIcon,
}

export const InstantTradeQuickOptionsEditButton = (props: Props) => {
  const Icon = stateIconMap[props.state]
  return (
    <Root
      $state={props.state}
      disabled={props.disabled}
      type={props.type}
      onClick={() => props.onClick?.()}
    >
      <Icon size={16} />
    </Root>
  )
}

const Root = styled.button<{ $state: State }>`
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid
    ${(x) => (x.$state === 'save' ? 'var(--up-9)' : 'var(--background-5)')};
  color: ${(x) => (x.$state === 'save' ? 'var(--up-9)' : 'unset')};
  border-radius: 10px;
  text-align: center;
  transition: all 0.15s linear;
  &:hover {
    border-color: ${(x) =>
      x.$state === 'save' ? 'var(--up-10)' : 'var(--background-9)'};
    background: ${(x) =>
      x.$state === 'save'
        ? 'rgba(var(--up-9-rgb), 0.2)'
        : 'var(--backgroundA-3)'};
  }
`
